
import { Component, Vue } from "vue-property-decorator";
import { OperationsManagementService, TenantWorkUserRelationshipPageDtoPagedResultDto } from "@/api/service-proxies";
import SchoolSelector from './components/school-selector.vue';
import moment from "moment";
import PagedListBase, {
  PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import Pagination from "@/components/Pagination/index.vue";

class getTenantWorkUserRelation extends PagedRequestDto {
  userName: string | null | undefined;
  phoneNumber: string | null | undefined;
  tenantName: string | null | undefined;
}

@Component({
  name: "schoolAnalysis",
  components: {
    SchoolSelector,
    Pagination
  },
  filters: {
    parseTime(time: string) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    }
  }
})
export default class schoolAnalysis extends PagedListBase<
  getTenantWorkUserRelation,
  TenantWorkUserRelationshipPageDtoPagedResultDto
> {
  // 分页参数
  pageSizeArray = [10, 20, 30, 50, 100];
  pageSizeper = 10;
  currentPage4 = 1;
  total = 0;
  pageCount = 0;

  // 搜索参数
  putRequest = new getTenantWorkUserRelation()
  isTableLoading = false;
  OperationsManagementService = new OperationsManagementService()

  // 主表数据
  tableList: any[] = [];

  // 时间显示
  currentTime = this.getCurrentTime();
  nowDay = moment().format('YYYY年MM月DD日');
  timer: NodeJS.Timeout | null = null;

  mounted() {
    this.timer = setInterval(this.updateTime, 1000);
    this.getpage();
  }

  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }

  getCurrentTime() {
    const now = new Date();
    const pad = (num: number) => String(num).padStart(2, '0');
    return `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  }

  updateTime() {
    this.currentTime = this.getCurrentTime();
  }

  updatePeople(row: any) {
    let id: number = -1
    let phone: string = '1'
    if (row != -1) {
      id = row.tenantWorkUserId
      phone = row.phoneNumber
    }
    if(phone == ""){
      phone="无"
    }
    this.$router.push({ path: `/managing-sys/updateAdministrator/${id}/${phone}` })
  }

  schoolChange(event: any) {
    this.putRequest.tenantName = event.tenantId;
  }

  handleDelete(row: any) {
    this.$confirm("确认删除吗?")
      .then(async () => {
        this.isTableLoading = true;
        this.OperationsManagementService
          .deleteOperations(row.tenantWorkUserId)
          .then(() => {
            this.$notify.success("删除成功");
          })
          .finally(() => {
            this.isTableLoading = false;
            this.getpage()
          });
      })
      .catch(() => { })
      .finally(() => {
        this.isTableLoading = false;
      });
  }

  handlePaginationChange(pagination: any) {
    this.currentPage4 = pagination.page;
    this.pageSizeper = pagination.limit;
    this.getpage();
  }

  refresh() {
    this.getpage();
  }

  getpage() {
    this.isTableLoading = true;

    this.putRequest.skipCount = (this.currentPage4 - 1) * this.pageSizeper;
    this.putRequest.maxResultCount = this.pageSizeper;

    this.OperationsManagementService
      .getTenantWorkUserRelationshipPage(
        this.putRequest.userName,
        this.putRequest.phoneNumber,
        this.putRequest.tenantName,
        this.putRequest.skipCount,
        this.putRequest.maxResultCount
      )
      .then((result) => {
        this.tableList = result.items || [];
        this.total = result.totalCount || 0;
        this.pageCount = Math.ceil(this.total / this.pageSizeper);
      })
      .catch((error) => {
        console.error('数据加载失败:', error);
        this.$message.error('主表数据加载失败');
      })
      .finally(() => {
        this.isTableLoading = false;
      });
  }
}
